module.exports = __webpack_public_path__ + "static/media/CloseHamburger.65b69639.svg";